module.exports = __webpack_public_path__ + "img/top.d2e348d9.png";